import React, { useContext } from 'react';

import { MasterApi } from '../apis';
import { api } from '../api';

const MasterApiContext = React.createContext(new MasterApi(api));

export const MasterApiProvider = MasterApiContext.Provider;
export const useMasterApi = (): MasterApi => useContext(MasterApiContext);
